module.exports = __webpack_public_path__ + "img/12_Tourismus_iPad_P.ee854d36.jpg";